import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCamSlashSq = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "31px",
	height: "31px",
	viewBox: "0 0 31 31",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title === undefined ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: "cam"
		}) : title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Page-1",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "cam-slash",
				transform: "translate(1.000000, 4.000000)",
				fill: "#5B1954",
				fillRule: "nonzero",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M28.56,22.73 C28.4220247,22.8978495 28.2172532,22.9965787 28,23 C27.8521831,22.994494 27.710837,22.9379556 27.6,22.84 L0.27,1.28 C-0.0303633762,1.03205283 -0.0831731303,0.591971548 0.15,0.28 C0.397947167,-0.0203633762 0.838028452,-0.0731731303 1.15,0.16 L28.48,21.72 C28.6337883,21.8372164 28.7304006,22.0143627 28.7456689,22.2071252 C28.7609372,22.3998878 28.6934175,22.5900346 28.56,22.73 Z M17.22,17.41 L18.45,18.41 C17.9997504,19.4679304 16.9597521,20.1533838 15.81,20.1500176 L4.31,20.1500176 C3.5480136,20.152669 2.81646612,19.851152 2.27765706,19.3123429 C1.73884801,18.7735339 1.43733102,18.0419864 1.43998243,17.28 L1.43998243,5.75 C1.44573521,5.49708979 1.47927017,5.24557759 1.54,5 L2.87,6.08 L2.87,17.25 C2.87545051,18.0430214 3.51697861,18.6845495 4.31,18.69 L15.81,18.69 C16.5370628,18.6838393 17.143758,18.1330805 17.22,17.41 L17.22,17.41 Z M9.91,4.31 L8.09,2.87 L15.81,2.87 C17.4005801,2.87 18.69,4.15941992 18.69,5.75 L18.69,11.24 L17.25,10.11 L17.25,5.75 C17.2445495,4.95697861 16.6030214,4.31545051 15.81,4.31 L9.91,4.31 Z M20.25,8.81 C20.0244532,8.48395851 20.1049186,8.03692842 20.43,7.81 L25.05,4.57 C25.4899994,4.26380916 26.0630314,4.22535064 26.54,4.47 C27.0168233,4.71805326 27.3142828,5.21253137 27.3100456,5.75 L27.3100456,17.21 C27.3106341,17.453631 27.2523078,17.6937978 27.14,17.91 L25.87,16.91 L25.87,5.75 L21.26,9 C21.1014374,9.11054149 20.9050874,9.15268595 20.715128,9.11695103 C20.5251687,9.08121611 20.3575552,8.97060326 20.25,8.81 Z",
					id: "Shape"
				})
			})
		})
	]
});
const ForwardRef = forwardRef(SvgCamSlashSq);
export default ForwardRef;
